import Image from "src/components/Image";

// ----------------------------------------------------------------------

export const BackgroundImage = () => {
	return (
		<Image
			src={`/images/background_dark.png`}
			sx={{ height: 550, width: "100%", position: "absolute" }}
			fit='cover'
		/>
	);
};

export default BackgroundImage;
